import { USER_ROLE_NAME_MAP } from 'app-config';
import { AxiosError } from 'axios';

// eslint-disable-next-line
export const isResponseError = <T = AxiosError>(error: any): error is T => {
	return error instanceof Error;
};

export const getUserRoleLabel = (role: string) => {
	return USER_ROLE_NAME_MAP[role] || role;
};

export const capitalize = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const errorMessageHandler = (err: any, defaultMsg = "Something went wrong!!!"): string => {
  const errorMessage = err?.message || err?.data?.errors?.[0] || err?.data?.message || err.errors?.[0] || defaultMsg;
  return errorMessage;
}

export const EMAIL_REGEX =
/^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;

export const normalizeEmail = (email: string): string =>
  email.trim().toLowerCase();

export const isValidEmail = (email: string): boolean =>
  EMAIL_REGEX.test(normalizeEmail(email));

export const getInvalidEmails = (emails: string[]): string[] =>
  emails.filter(email => !isValidEmail(email));
